export enum NavigationRoute {
  Home = 'home',
  Financial = 'financeiro',
  ServiceOrders = 'ordens-servico',
  SAC = 'sac',
  Invoices = 'notas-fiscais',
  DigitalAccepts = 'aceites-digitais',
  CreditCard = 'cartao',
  TravelAlert = 'aviso-viagem',
  PhoneUtils = 'telefone-uteis',
  DocumentsUtils = 'documentos-uteis',
  Monitoring = 'monitoramento',
  Track = 'rastreamento',
  Contract = 'contrato',
  OsDetail = 'detalhe-os',
  StatementOfDebts = 'declaracao-debitos',

  Theme = 'theme',
  Configs = 'configs',
  SocialMedia = 'redes-socias',
  ProspectSettings = 'prospect-settings',
  EventsSettings = 'events-settings'
}

export const screensClientNavigator = {
  [NavigationRoute.Home]: { path: NavigationRoute.Home.toString() },
  [NavigationRoute.Financial]: { path: NavigationRoute.Financial.toString() },
  [NavigationRoute.Invoices]: { path: NavigationRoute.Invoices.toString() },
  [NavigationRoute.SAC]: { path: NavigationRoute.SAC.toString() },
  [NavigationRoute.DigitalAccepts]: { path: NavigationRoute.DigitalAccepts.toString() },
  [NavigationRoute.ServiceOrders]: { path: NavigationRoute.ServiceOrders.toString() },
  [NavigationRoute.CreditCard]: { path: NavigationRoute.CreditCard.toString() },
  [NavigationRoute.TravelAlert]: { path: NavigationRoute.TravelAlert.toString() },
  [NavigationRoute.PhoneUtils]: { path: NavigationRoute.PhoneUtils.toString() },
  [NavigationRoute.DocumentsUtils]: { path: NavigationRoute.DocumentsUtils.toString() },
  [NavigationRoute.Monitoring]: { path: NavigationRoute.Monitoring.toString() },
  [NavigationRoute.Track]: { path: NavigationRoute.Track.toString() },
  [NavigationRoute.OsDetail]: { path: NavigationRoute.OsDetail.toString() },
  [NavigationRoute.Contract]: { path: NavigationRoute.Contract.toString() },
  [NavigationRoute.StatementOfDebts]: { path: NavigationRoute.StatementOfDebts.toString() }
}

export const screensAdminNavigator = {
  [NavigationRoute.Theme]: { path: NavigationRoute.Theme.toString() },
  [NavigationRoute.Configs]: { path: NavigationRoute.Configs.toString() },
  [NavigationRoute.SocialMedia]: { path: NavigationRoute.SocialMedia.toString() },
  [NavigationRoute.ProspectSettings]: { path: NavigationRoute.ProspectSettings.toString() },
  [NavigationRoute.EventsSettings]: { path: NavigationRoute.EventsSettings.toString() }
}
